export const CLASS_NAME = 'cst-group-list'
